module.exports = "data:image/webp;base64,UklGRrwAAABXRUJQVlA4ILAAAADQBACdASoZABkAPpE+mkkloyKhKAqosBIJZQC35oAAIziztP1gSp9mr2l5LXP4AAD+hk+AQ7gnG5leTLirpE4G1q16QA5Y3y9ez7wOo+PfjGN0+6AB+mx/i2K4NKBwx8Z3ZAqXpwA5Rm1dPDpY1DGAVH4wjWoCOUUj8HTFDfjs471cKkMRsiu+VDNsCfT4eGe1wxj5RTUYWPAGD3IWs2KW6+6yyYE1bGisfuYUWzAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/gold.webp
// module id = AOl2
// module chunks = 14